import { html, nothing } from 'lit';
import { distributionData, distributionMetadata } from '../types.js';
import { getLanguage } from '../lang.js';
import { langCode } from '../../../utils/getLangCode.js';
import { ifDefined } from 'lit/directives/if-defined.js';
export function DistributionAccessibleTable({
  metadata,
  data,
  locale,
  unit,
  description,
  id
}: {
  metadata: distributionMetadata[];
  data: distributionData;
  locale: langCode;
  unit?: string;
  description?: string;
  id?: string;
}) {
  const language = getLanguage(locale);
  const getValue = (key: string) => data.values[key] || 0;
  const {
    includeMeta,
    excludeMeta
  } = getMetaByExclude(metadata);
  const total = includeMeta.reduce((sum, x) => sum + getValue(x.key), 0);
  const showPercentage = total > 0;
  return html`
    <table class="one-ux-accessibility--screen-reader" aria-label=${data.name} id=${ifDefined(id)}>
      ${!description ? nothing : html`
            <caption lang=${locale}>
              ${description}
            </caption>
          `}
      <thead>
        <tr>
          <th scope="col" lang=${language.locale}>${language.translations.total}</th>
          ${[...includeMeta, ...excludeMeta].map(x => html`<th>${x.name}</th>`)}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${total} ${unit}</td>
          ${includeMeta.map(x => html`<td>
                ${getValue(x.key)} ${unit} ${showPercentage ? `(${Math.round(100 * getValue(x.key) / total)}%)` : ''}
              </td>`)}
          ${excludeMeta.map(x => html`<td>${getValue(x.key)} ${unit} (${language.translations.excluded})</td>`)}
        </tr>
      </tbody>
    </table>
  `;
}
function getMetaByExclude(metadata: distributionMetadata[]) {
  const includeMeta = [];
  const excludeMeta = [];
  for (let i = 0; i < metadata.length; ++i) {
    const entry = metadata[i];
    if (entry.exclude) {
      excludeMeta.push(entry);
    } else {
      includeMeta.push(entry);
    }
  }
  return {
    includeMeta,
    excludeMeta
  };
}